// Opendock publishes /en/, /es/ and /pt/ (there is no /pt-br/ or /es-mx/), so
// every LATAM locale maps to the closest Opendock language.
const OPENDOCK_LANG = {
  'en-LATAM': 'en',
  'pt-BR': 'pt',
  'es-MX': 'es',
  'es-CO': 'es',
};

// Home page of Opendock in the visitor's language, e.g. `${base}/pt/`.
// Locales Opendock has no version for fall back to its default (root) site.
export function getOpendockUrl(locale) {
  const lang = OPENDOCK_LANG[locale];
  return `${process.env.OPENDOCK_URL}/${lang ? `${lang}/` : ''}`;
}
